import { Cross2Icon } from '@radix-ui/react-icons';
import { Table } from '@tanstack/react-table';
import { Button } from '@/components/ui/button.tsx';
import { Input } from '@/components/ui/input.tsx';

import { UsersTableFacetedFilter } from './users-table-faceted-filter.tsx';
import { statuses } from '@/features/users/schemas/users.utils.ts';
import { useRolesQuery } from '@/features/users/hooks/queries/use-roles-query.ts';

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function UsersTableToolbar<TData>({ table }: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0;
  const { data: rolesData } = useRolesQuery();
  const roles = rolesData?.map((r) => ({ label: r.label, value: r.label })) ?? [];

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 flex-wrap items-center gap-2">
        <Input
          placeholder="Filter users by email"
          value={(table.getColumn('email')?.getFilterValue() as string) ?? ''}
          onChange={(event) => table.getColumn('email')?.setFilterValue(event.target.value)}
          className="h-8 w-[150px] bg-white lg:w-[250px]"
        />
        {table.getColumn('status') && (
          <UsersTableFacetedFilter
            column={table.getColumn('status')}
            title="Status"
            options={statuses}
          />
        )}
        {table.getColumn('role') && (
          <UsersTableFacetedFilter
            column={table.getColumn('role')}
            title="Role"
            options={roles}
          />
        )}
        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => table.resetColumnFilters()}
            className="h-8 px-2 lg:px-3"
          >
            Reset
            <Cross2Icon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
